// extracted by mini-css-extract-plugin
export default {"my-topics":"MyTopics_my-topics__ywKzO"};